// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"28":"novedades","273":"habitualist","404":"usuarios","588":"circulares","757":"not-found","902":"administrador"}[chunkId] || chunkId) + "." + {"28":"26aee174","196":"30b3ab1a","213":"068c7bb6","273":"0bf52e63","404":"92b5af58","522":"cb9237a4","588":"7bcce36e","757":"6a827bc1","902":"26bb2f6c"}[chunkId] + ".js";
};